import React from 'react';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import { useQuote } from './QuoteDialog';
export function MobileStickyCTA() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    openQuote
  } = useQuote();
  if (!isMobile) return null;
  return <Box sx={{
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: t => t.zIndex.appBar + 1,
    bgcolor: 'white',
    borderTop: '1px solid',
    borderColor: 'divider',
    p: 1.5,
    // Respect iOS safe-area inset at the bottom of the screen
    pb: 'calc(12px + env(safe-area-inset-bottom))',
    boxShadow: '0 -4px 12px rgba(0,0,0,0.08)'
  }} data-id="element-100">
      <Button variant="contained" color="secondary" fullWidth onClick={openQuote} sx={{
      py: 1.5,
      fontSize: '1.05rem',
      fontWeight: 700
    }} data-id="element-101">
        Get a Free Quote
      </Button>
    </Box>;
}